import { useCallback } from 'react';
import usePath from 'helpers/hooks/usePath'; // Update the path based on your actual project structure

export default function useTrackEvent() {
  const { pathWithoutQuery } = usePath();

  const trackEvent = useCallback(
    (data: { [key: string]: unknown }) => {
      if (typeof window === 'undefined') return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ...data,
        category: data.category ?? pathWithoutQuery,
      });
    },
    [pathWithoutQuery],
  );

  return trackEvent;
}
